export default __webpack_public_path__ + "static/media/Varied Pop 5.2b4cddb0.mp3";